import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Mariana G.',
  location: 'Corrientes',
  text: '"Arranqué vendiendo chipá el primer finde después de comprar el pack. En una semana ya tenía 8 clientes fijos."'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  text: '"Los alfajores me salen perfectos ahora. El secreto del 70/30 de maicena cambió todo. Mis clientes me piden cajas de regalo cada semana."'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  text: '"El Tomo 6 solo ya vale todo. Por fin sé exactamente cuánto cobrar y nunca más regalé trabajo."'
}];
export function TestimonialsTop() {
  return <section className="py-10 px-4 bg-cream-light pt-[35px] pb-[35px]" data-id="element-296">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-297">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white p-6 rounded-2xl shadow-warm border border-cream-dark relative" data-id="element-298">
            <div className="flex items-center gap-4 mb-4" data-id="element-299">
              <div className="w-12 h-12 bg-cream-dark rounded-full flex items-center justify-center font-serif font-bold text-carbon text-lg" data-id="element-300">
                {t.initials}
              </div>
              <div data-id="element-301">
                <div className="flex text-yellow-400 mb-1" data-id="element-302">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-303" />)}
                </div>
                <p className="font-bold text-sm text-carbon" data-id="element-304">{t.name}</p>
                <p className="text-xs text-carbon-lighter" data-id="element-305">{t.location}</p>
              </div>
            </div>
            <p className="text-carbon-lighter italic text-sm leading-relaxed" data-id="element-306">
              {t.text}
            </p>
          </motion.div>)}
      </div>
    </section>;
}